(function ($) {
    $(document).ready(function ($) {
        $('body').on('keydown', '.c-loop-focus', focusElements)
            .on("keyup", ":not(.c-loop-focus)", moveFocusToClose);
    });

    function focusElements(event) {
        var $this = $(this);

        if (event.keyCode === 27) { // esc
            $(event.target).find('.c-loop-focus__close').trigger('click');
        }
        if (event.keyCode === 9) { // tab
            // jQuery formatted selector to search for focusable items
            var focusableElementsString = "a[href], area[href], input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]";

            // get list of all children elements in given object
            var children = $this.find('*');

            // get list of focusable items
            var focusableItems = children.filter(focusableElementsString).filter(':visible');

            // get currently focused item
            var focusedItem = $(document.activeElement);

            // get the number of focusable items
            var numberOfFocusableItems = focusableItems.length;

            var focusedItemIndex = focusableItems.index(focusedItem);

            if (!event.shiftKey && (focusedItemIndex === numberOfFocusableItems - 1)) {
                focusableItems.get(0).focus();
                event.preventDefault();
            }
            if (event.shiftKey && focusedItemIndex === 0) {
                focusableItems.get(numberOfFocusableItems - 1).focus();
                event.preventDefault();
            }
        }
    }

    function moveFocusToClose(event) {
        var $element = $('.c-loop-focus:visible'),
            focusedItem = $(document.activeElement),
            inModal = !!focusedItem.parents('.c-loop-focus').length;

        if ($element.length && event.keyCode === 9 && inModal === false) { // tab
            $element.find('.c-loop-focus__close').focus();
        }
    }
}(jQuery));
